import React from 'react';
import PropTypes from 'prop-types';
import { toTitleCase } from '../../helpers/stringConstantHelpers';


const AgentNameBlock = ({ selectedAgent, nameBold }) => {
    return (
        <div className="d-flex">
            <div>
                <h4 className={`mb-0 pb-0 ${nameBold ? 'font-weight-bold' : ''}`}>
                    {selectedAgent?.agentName}
                </h4>
                <p className="max-content mb-0 helix-heading helix-gray-6">{toTitleCase(selectedAgent?.officeName)}</p>
            </div>
        </div>
    );
};

AgentNameBlock.propTypes = {
    selectedAgent: PropTypes.shape({
        agentName: PropTypes.string,
        officeName: PropTypes.string,
    }),
    nameBold: PropTypes.bool,
};

export default AgentNameBlock;
